import { useState } from "react";

import { ImageLogo } from "./ImageLogo";
import { TextLogo } from "./TextLogo";

import type { CompanyLogoProps } from "./types";

export function CompanyLogo({ size = "default", company, testIdPrefix }: CompanyLogoProps) {
  const [failedLogoUrl, setFailedLogoUrl] = useState<string | null>(null);
  const logoUrl = company?.logoUrl ?? "";

  if (!company?.logoUrl || failedLogoUrl === logoUrl) {
    return <TextLogo size={size} testIdPrefix={`${testIdPrefix}-company`} company={company} />;
  } else {
    return (
      <ImageLogo
        size={size}
        testIdPrefix={`${testIdPrefix}-company`}
        company={company}
        onError={() => setFailedLogoUrl(logoUrl)}
      />
    );
  }
}
